import { createFileRoute } from '@tanstack/react-router';
import { FuelEntriesClient } from '@/features/fuel/FuelEntriesClient';

export const Route = createFileRoute('/_shell/fuel/entries')({
  component: FuelEntriesClient,
});
